import React, { ReactNode } from 'react';
import { MonitorIcon, SmartphoneIcon, TabletIcon } from 'lucide-react';
export type Device = 'desktop' | 'tablet' | 'mobile';
const WIDTHS: Record<Device, string> = {
  desktop: '100%',
  tablet: '768px',
  mobile: '390px'
};
const OPTIONS: {
  value: Device;
  label: string;
  icon: typeof MonitorIcon;
}[] = [{
  value: 'desktop',
  label: 'Escritorio',
  icon: MonitorIcon
}, {
  value: 'tablet',
  label: 'Tablet',
  icon: TabletIcon
}, {
  value: 'mobile',
  label: 'Móvil',
  icon: SmartphoneIcon
}];
interface DevicePreviewProps {
  device: Device;
  onDeviceChange: (device: Device) => void;
  children: ReactNode;
  toolbar?: ReactNode;
}
export function DevicePreview({
  device,
  onDeviceChange,
  children,
  toolbar
}: DevicePreviewProps) {
  return <div className="flex h-full min-w-0 flex-col rounded-lg border border-border bg-surface" data-id="element-576" data-mp="i7cb473ubjgi">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-border px-3 py-2" data-id="element-577" data-mp="dbwytjlhdvm7">
        <div className="flex gap-1 rounded-md bg-background p-1" role="group" aria-label="Tamaño de la vista previa" data-id="element-578" data-mp="roa21seilsjy">
          {OPTIONS.map(option => <button key={option.value} type="button" onClick={() => onDeviceChange(option.value)} aria-pressed={device === option.value} aria-label={option.label} className={`flex h-8 w-9 items-center justify-center rounded-sm transition-colors ${device === option.value ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-surface'}`} data-id="element-579" data-mp="wgtc4fdzu5k0">
              <option.icon className="h-4 w-4" data-id="element-580" data-mp="16cwhdu456kb6" />
            </button>)}
        </div>
        {toolbar}
      </div>
      <div className="flex-1 overflow-auto p-4" data-id="element-581" data-mp="3m411gn8d4emt">
        <div className="mx-auto overflow-hidden rounded-lg border border-border bg-background shadow-sm transition-all" style={{
        width: WIDTHS[device],
        maxWidth: '100%'
      }} data-id="element-582" data-mp="3m6dh2tqnecwp">
          {children}
        </div>
      </div>
    </div>;
}